import React, { useState } from "react";
import { doForgotPassword } from "@AUTH";
import { Form, Input, Button, Space } from "antd";
import { useHistory } from "react-router";
import OtpPage from "../otp";
import { jetPartner, hepsiTruck, cargoPlane } from "../../../assets/icons";

const ForgotPasswordPage = () => {
  // const { setToken } = useContext(AuthContext);
  const [verification, setVerification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadedImages, setLoadedImages] = useState([]);
  const history = useHistory();

  const handleForgotPassword = async (val) => {
    setLoading(true);
    const verification = await doForgotPassword(val);

    // console.log(verification);
    if (verification) {
      setVerification(verification);
    }
    setLoading(false);
  };
  return (
    <>
      <div className="app-login">
        <div className="app-login-logo-container">
          <div className="app-login-logo-logos">
            <img
              src={jetPartner}
              alt=""
              className="jetPartner-logo"
              style={{ visibility: loadedImages.length > 2 ? true : false }}
              onLoad={() => {
                let tempLoaded = [...loadedImages];
                tempLoaded.push("jetPartner");
                setLoadedImages(tempLoaded);
              }}
            />
            <img
              src={cargoPlane}
              alt=""
              className="cargoPlane-logo"
              style={{ visibility: loadedImages.length > 2 ? true : false }}
              onLoad={() => {
                let tempLoaded = [...loadedImages];
                tempLoaded.push("cargo");
                setLoadedImages(tempLoaded);
              }}
            />
            <img
              src={hepsiTruck}
              alt=""
              className="hepsiTruck-logo"
              style={{ visibility: loadedImages.length > 2 ? true : false }}
              onLoad={() => {
                let tempLoaded = [...loadedImages];
                tempLoaded.push("truck");
                setLoadedImages(tempLoaded);
              }}
            />
          </div>
        </div>
        <div className="app-login-form-container">
          {verification ? (
            <OtpPage verification={verification} />
          ) : (
            <Space
              direction="vertical"
              size="large"
              style={{
                marginTop: "5%",
                width: "70%",
                justifyContent: "space-between",
              }}
            >
              <h2>Hoş geldiniz</h2>
              <h4>Şifremi Unuttum</h4>
              <Form
                layout="vertical"
                name="basic"
                onFinish={(val) => handleForgotPassword(val)}
                style={{ width: "100%" }}
              >
                <Form.Item
                  label="E-Posta"
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Lütfen e-posta adresinizi kontrol ediniz.",
                    },
                    {
                      required: true,
                      message: "Lütfen e-posta adresinizi giriniz.",
                    },
                  ]}
                >
                  <Input size="large" style={{ borderRadius: "10px" }} />
                </Form.Item>

                <Form.Item>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                    style={{ background: "#F47729", borderRadius: "10px" }}
                  >
                    Şifremi Unuttum
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    size="small"
                    type="text"
                    // htmlType="submit"
                    // block
                    loading={loading}
                    onClick={() => history.push("/auth/login")}
                    // style={{ background: "#F47729", borderRadius: "10px" }}
                  >
                    Giriş bilgilerinizi hatırlıyor musunuz? Giriş yapın
                  </Button>
                </Form.Item>
              </Form>
            </Space>
          )}
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
